import React, { use, useEffect, useState } from "react";
import Footer from "../../../../Kryzen Alpha App/Components/Footer/footer";
import StepRoutes from "../../../../Kryzen Alpha App/Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../../Kryzen Alpha App/Components/layouts/loading";
import { Toast } from "../../../../Kryzen Alpha App/CustomComponent/toast";
import performRequest from "../../../../Kryzen Alpha App/api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcReading, FcStackOfPhotos } from "react-icons/fc";
import { useSelector } from "react-redux";
import { BsCheck2Square } from "react-icons/bs";
import SimpleButton from "../../../Components/layouts/simple_button";

const ViewCandidateDetails = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const userRole = useSelector((state) => state.login);
  const role = userRole?.user?.Role;

  let navigate = useNavigate();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/interview/interview-candidate/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting candidate details!");
        }

        setLoading(false);
      })

      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcReading className="fs-2 me-1" />
                  View Candidate Details
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header d-flex justify-content-between">
              <div>
                <h2 className="page-title">Candidate Details</h2>
              </div>
            </div>

            <div className="card-body">
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Name :</label>
                  <div className="w-100 col">
                    {data.Fname || data.Lname
                      ? `${data.Fname || ""} ${data.Lname || ""}`.trim()
                      : "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Email :</label>
                  <div className="w-100 col">{data?.email || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Phone Number :
                  </label>
                  <div className="w-100 col">{data?.phoneNo || "N/A"}</div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Assigned Interviewer :
                  </label>
                  <div className="w-100 col">
                    {data?.assignedInterviewer || "N/A"}
                  </div>
                </div>
              )}

              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Job Type :</label>
                  <div className="w-100 col">{data?.jobType || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Inverview Schedule Date :
                  </label>
                  <div className="w-100 col">
                    {data?.interviewScheduleDate || "N/A"}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Employee Type :
                  </label>
                  <div className="w-100 col">{data?.Etype || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Department :</label>
                  <div className="w-100 col">{data?.departments || "N/A"}</div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Skills :</label>
                  <div className="w-100 col">{data?.skills || "N/A"}</div>
                </div>
              )}
              {/* {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Recruter Remark :
                  </label>
                  <div className="w-100 col">
                    {data?.recruterRemark || "N/A"}
                  </div>
                </div>
              )} */}

              <div className="mb-3 row">
                <label className="w-25 form-label col-3">Resume</label>

                <div className="w-100 col">
                  {data?.uploadcv ? (
                    <>
                    
                      {data.uploadcv.endsWith(".pdf") ? (
                        <iframe
                          src={data.uploadcv}
                          title="Resume Preview"
                          width="100%"
                          height="500px"
                          style={{
                            border: "1px solid #e5e7eb",
                            borderRadius: "8px",
                          }}
                        />
                      ) : 
                      /\.(jpg|jpeg|png)$/i.test(data.uploadcv) ? (
                        <img
                          src={data.uploadcv}
                          alt="Resume"
                          style={{
                            maxWidth: "100%",
                            maxHeight: "500px",
                            borderRadius: "8px",
                            border: "1px solid #e5e7eb",
                          }}
                        />
                      ) : (
                     
                        <div>
                          <p>Preview not available</p>
                        </div>
                      )}

                    
                      <div style={{ marginTop: "10px" }}>
                        <a
                          href={data.uploadcv}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn btn-sm btn-primary me-2"
                        >
                          Open Resume
                        </a>

                        <a
                          href={data.uploadcv}
                          download
                          className="btn btn-sm btn-outline-secondary"
                        >
                          Download
                        </a>
                      </div>
                    </>
                  ) : (
                    <span className="text-muted">Resume Not Available</span>
                  )}
                </div>
              </div>

                <hr></hr>
              <div className="mt-4">
                <h3 className="mb-3">Follow Up / Remark</h3>

                {data?.followUp?.length > 0 ? (
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead>
                        <tr>
                          <th>Followup</th>
                          <th>FollowUp Date</th>
                        </tr>
                      </thead>

                      <tbody>
                        {data.followUp.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.followUp || "N/A"}</td>
                            <td>{item?.followUpDate || "N/A"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : null}
              </div>
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <button
                  onClick={() => {
                    navigate(`/update-candidate-details/${id}`);
                  }}
                  className="btn mx-1 mt-2 btn-primary"
                >
                  {" "}
                  <BsCheck2Square className="fs-2 me-2" />
                  EDIT CANDIDATE DETAILS
                </button>

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewCandidateDetails;
